import { useTranslation } from 'react-i18next';
import { useModal } from '@/hooks';
import { SectionBox } from '@/components/SectionBox';
import { Button } from '@/components/Button';
import { CompareReportsModal } from '@/components/_modals/CompareReportsModal';

import styles from './OnlyForVerifiedSection.module.sass';

interface OnlyForVerifiedSectionProps {
  title: string;
  description: string;
}

export const OnlyForVerifiedSection = ({
  title,
  description,
}: OnlyForVerifiedSectionProps) => {
  const { t } = useTranslation();

  const {
    isOpen: isOpenCompareReportsModal,
    onOpenModal: handleOpenCompareReportsModal,
    onCloseModal: handleCloseCompareReportsModal,
  } = useModal();

  return (
    <>
      <SectionBox>
        {{
          className: styles.sectionDimmed,
          title: <div className={styles.sectionTitle}>{title}</div>,
          body: (
            <div className={styles.sectionDimmedBody}>
              {description}
              <Button
                size="m"
                type="primary-black"
                className={styles.sectionDimmedButton}
                corner="rect"
                onClick={handleOpenCompareReportsModal}
              >
                {t('translation.upgrade_pro_plus_btn')}
              </Button>
            </div>
          ),
        }}
      </SectionBox>

      <CompareReportsModal
        isOpen={isOpenCompareReportsModal}
        onClose={handleCloseCompareReportsModal}
      />
    </>
  );
};
